import React from "react";

const exps = [
  {
    title: "Atardecer privado",
    duration: "≈ 2 horas",
    desc: "Una salida breve, visual y muy especial para disfrutar de la hora dorada desde cubierta. Ideal para parejas, familias o grupos pequeños que buscan un momento tranquilo y diferente.",
    img: "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/dlsx3pmm_PHOTO-2025-01-24-16-28-51.jpg",
    span: "md:col-span-2",
  },
  {
    title: "Media jornada privada",
    duration: "4 horas",
    desc: "La experiencia principal del Zorba: navegación tranquila por la costa, baño según condiciones, aperitivo a bordo y tiempo para conocer la historia del barco.",
    img: "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/6rn211s0_f8097867-5919-4560-96a8-06374620ecb8.jfif",
    span: "",
  },
  {
    title: "Jornada completa privada",
    duration: "8 horas",
    desc: "Una experiencia más pausada para vivir el Zorba sin prisa: navegar, fondear si las condiciones lo permiten, disfrutar del entorno y pasar el día a bordo de un velero clásico.",
    img: "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/er0az49x_IMG-20240809-WA0005.jpg",
    span: "",
  },
  {
    title: "Empresas e incentivos",
    duration: "Media o jornada completa",
    desc: "Un escenario singular para clientes VIP, equipos, networking o eventos privados. Lejos de una sala de reunión, cerca del mar y con una historia que se recuerda.",
    img: "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/hy8bzyan_IMG-20240921-WA0002.jpg",
    span: "",
  },
  {
    title: "Rodajes y fotografía",
    duration: "A medida",
    desc: "Un velero clásico con experiencia en cine y documental, disponible como localización, embarcación de escena o soporte visual para campañas, rodajes y producciones de marca.",
    img: "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/rmmes6oo_339c7fff-568b-4413-af5d-d1fea53cd502.jfif",
    span: "md:col-span-2",
  },
];

export default function Experiences() {
  return (
    <section id="experiencias" className="section-pad bg-background" data-testid="experiences-section">
      <div className="container-tight">
        <div className="max-w-3xl mb-14 md:mb-20">
          <p className="label-eyebrow text-wood mb-4">Experiencias</p>
          <h2 className="font-heading text-4xl md:text-5xl leading-tight text-navy" data-testid="experiences-title">
            El Zorba se reserva completo. La experiencia se adapta a ti.
          </h2>
          <p className="mt-5 text-navy/70 text-lg leading-relaxed">
            El barco se alquila siempre de manera privada, con patrón incluido y capacidad máxima hasta 12 pasajeros más tripulación. Puedes elegir entre media jornada —4 horas— o jornada completa —8 horas—, y adaptar la salida al tipo de plan: una experiencia tranquila entre particulares, un encuentro de empresa o una producción audiovisual.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6">
          {exps.map((e, i) => (
            <article
              key={e.title}
              data-testid={`experience-card-${i}`}
              className={`group relative overflow-hidden rounded-md ${e.span} h-[340px] md:h-[420px] cursor-pointer`}
            >
              <img
                src={e.img}
                alt={e.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-transparent" />

              <span className="absolute top-5 left-5 inline-flex items-center text-[10px] tracking-[0.2em] uppercase font-medium px-2.5 py-1 rounded-full bg-white/95 text-navy shadow-sm">
                {e.duration}
              </span>

              <div className="absolute inset-x-0 bottom-0 p-7 flex flex-col text-white">
                <h3 className="font-heading text-2xl md:text-3xl leading-tight">{e.title}</h3>
                <p className="mt-2 text-sm md:text-base text-white/85 max-w-md leading-relaxed">
                  {e.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href="https://wa.me/34649927028?text=Hola%2C%20me%20gustar%C3%ADa%20consultar%20disponibilidad%20del%20velero%20Zorba."
            target="_blank"
            rel="noopener noreferrer"
            data-testid="experiences-whatsapp-btn"
            className="btn-pill bg-navy text-white px-8 py-3.5 inline-block font-medium hover:bg-[#142949]"
          >
            Consultar disponibilidad por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
